import type { HeroProps } from '@/components/transparency/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/transparency/transparency_report_og.png';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    ogImage: og.src,
    title: 'Lemonade: Transparency',
    metaTitle: 'Lemonade: Transparency',
    description:
      'Learn how Lemonade operates with transparency, from handling claims to donating leftover premiums, and see our annual Giveback reports.',
  },
  hero: {
    title: 'Transparency Chronicles',
    subtitle: "Join our exclusive mailing list to receive Lemonade's \n transparency reports before everyone else",
  },
};
